/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invalidlinktitle2Inputs */

const zh_auth_invalidlinktitle2 = /** @type {(inputs: Auth_Invalidlinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接无效或已过期`)
};

const en_auth_invalidlinktitle2 = /** @type {(inputs: Auth_Invalidlinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid or expired link`)
};

const es_auth_invalidlinktitle2 = /** @type {(inputs: Auth_Invalidlinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace inválido o expirado`)
};

/**
* | output |
* | --- |
* | "Invalid or expired link" |
*
* @param {Auth_Invalidlinktitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_invalidlinktitle2 = /** @type {((inputs?: Auth_Invalidlinktitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invalidlinktitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_invalidlinktitle2(inputs)
	if (locale === "en") return en_auth_invalidlinktitle2(inputs)
	return es_auth_invalidlinktitle2(inputs)
});
export { auth_invalidlinktitle2 as "auth_invalidLinkTitle" }